import { CallCheckListPayload } from "./call-checklist-model";
import { DispatchDataPayload } from "./dispatch-request.model";

export class RequestPayload {
    CcrId!: string;
    orderType!: string;
    UserId: string | null = null;
    UserName: string | null = null;
    firstName!: string; 
    lastName!: string; 
    houseNumber!: string; 
    street!: string;  
    city!: string;
    newCity!: string;
    state!: string;  
    gender: string | null = null;
    zip!: string;  
    safePhone!: string; 
    extension!: string;
    ssn!: string;
    contractAccountNo!: string;
    customerRequestInformation!: string;
    reqReconnectDt!: Date | null;
    reconnectApptTm!: string;
    callCheckList!: CallCheckListPayload | null;
    newHouseNumber: string = '';
    newStreet: string = '';
    newCityValue: string = '';
    newState: string = '';
    newZip: string = '';
    newMeterNumber: string = '';
    newInstallationNumber: string= '';
    driverLicenseState: string = '';
    driverLicenseNumber: string = '';
    maritalStatus: string = '';
    setupInSpouseName: string = '';
    spouseSSN: string = '';
    IsAutomaticBankDraft?: string = '';
    IsAverageMonthlyBilling?: string = "";
    IsElderlyDisabled?:string = "";
    IsBudgetPlan: string = "";
    IsBadDebtAtPremise: string ="";
    DepositAm: number = 0;
    Comments:string = "";
    oldStreet: string = '';
    oldCity: string = '';
    oldState: string = '';
    oldZip: string = '';
    oldMeterNumber: string = '';
    oldInstallationNumber: string= '';
    OldHouseNumber: string = '';
    ReqToDisconnectDt!: Date | null;
    Spouse_MR_MS: string = '';
    SpouseFirstName: string = '';
    SpouseLastName: string = '';
    dispatchData!: DispatchDataPayload | null;
    newSvcCity: string = '';
    SvcToBeginDt!: Date | null;
    UpdateCcrId!: string;
    isDispatchChanged: boolean = false;
    isCustomercallChanged: boolean = false;
  }

  export interface CustomerCallRecord {
    CcrId: string; 
    OrderType: string; 
    FirstName: string; 
    LastName: string; 
    HouseNumber: string; 
    Street: string; 
    City: string; 
    NewCity: string; 
    State: string; 
    Gender: string; 
    Zip: string; 
    SafePhone: string; 
    Extension: string; 
    WorkDt: string;
    Ssn: string; 
    ContractAccountNo: string;  
    CustomerRequestInformation: string; 
    ReqReconnectDt: Date | null; 
    ReconnectApptTm: string;  
    DataInSap: string; 
    AnalystEntry: string; 
    DispatchEntry: string; 
  }
  
  export interface Emergencies { 
    AdditionalEmergency: string; 
    AdditionalOutsideLocation: string; 
    Appliance: string; 
    BuildingSelected: string; 
    CallerTypes: string | null; 
    IsLeakHousePiping: string; 
    IsLeakAppliance: string; 
    LeakageType: string | null; 
    LeakedSelected: string; 
    OdorFirstNoticed: string; 
    Room: string; 
    SoundGas: string; 
    Type: string; 
    WorkInProgress: string; 
  }
  
  export interface Dispatch {
    SapWo: string; 
    DispatchFirstName: string; 
    DispatchLastName: string;  
    StatusUpdateNotes: string; 
    DispatchTechId: string;
    DataInSap: string;
    AnalystEntry: string;
    DispatchEntry: string; 
  }

  export interface HistoryLogs {
    ReqestedDate: string; 
    AnalystName: string; 
    Action: string;  
  }

    export interface HistoryLogsRecords{
    ResultCode: string;
    ResultDescription: string;
    Payload: any;
}

  export interface ApiResponse { 
    ResultCode: string; 
    ResultDescription: string; 
    Payload: { 
      customerCallRecord: CustomerCallRecord; 
      CustomerNewServiceRecord:any;
      CustomerOldSvcAddressRecord:any;
      emergencies: Emergencies; 
      dispatch: Dispatch; 
      historyLogs: any;
    };
    CCRID: string; 
  }